import React ,{ useEffect, useState} from "react";
import Title from "./Title";
import { policy, terms } from "../common/data";
import ImageBanner from "./ImageBanner";
import { getData } from "../common/strapiUrl";
import ReactMarkdown from "react-markdown";

const PrivacyAndTerms = ({ title = "Trip Merchant | Privacy Policy" }) => {
  const [data, setData] = useState();

    useEffect(() => {
        getData(`/pages/${title == "Trip Merchant | Privacy Policy" ? 17 : 16}`).then((res) => {
          setData(res?.data);
        });
      }, [title]);
  return (
    <>
      <Title title={title} />
      <div className="last-minute-deals">
        <ImageBanner title={title} />
      </div>
      <div className="container my-3">
        <h3 className="text-center mt-2">{title}</h3>
        <div
          // dangerouslySetInnerHTML={{
          //   __html: title == "Trip Merchant | Privacy Policy" ? policy : terms,
          // }}
        />
        <ReactMarkdown>{data?.attributes?.blooks[0]?.Cards[0]?.detail || "Loading..."}</ReactMarkdown>
      </div>
    </>
  );
};

export default PrivacyAndTerms;
